import type { ReactElement, ReactNode } from 'react'
import { FormPanelShadcnComponent } from 'app/components/form-panel/FormPanelShadcnComponent'
import { cn } from 'app/lib/utils'
import type { SectionIcon } from 'app/types/live-alerts'

/**
 * Rows stay on the page when the section is off, dimmed rather than hidden, so
 * someone can see what they are switching back on before they switch it.
 */
export function NotificationSectionCard({
  icon: Icon,
  title,
  description,
  control,
  enabled,
  children,
}: {
  icon: SectionIcon
  title: string
  description: string
  control: ReactNode
  enabled: boolean
  children: ReactNode
}): ReactElement {
  return (
    <FormPanelShadcnComponent
      cols={6}
      // The description goes in the title rather than the panel's `subtitle`
      // slot, where it floats alone in the body with nothing to attach to.
      title={
        <span className="flex items-start gap-2">
          <Icon className="mt-0.5 h-5 w-5 shrink-0 text-subtle" strokeWidth={1.5} />
          <span className="flex min-w-0 flex-col gap-y-0.5">
            <span>{title}</span>
            <span className="text-body-xs font-normal normal-case text-subtle">{description}</span>
          </span>
        </span>
      }
      learnMore={control}
    >
      <div className={cn(!enabled && `opacity-60`)}>{children}</div>
    </FormPanelShadcnComponent>
  )
}
